import { render, staticRenderFns } from "./51rp.vue?vue&type=template&id=0afc52fe&scoped=true&"
import script from "./51rp.vue?vue&type=script&lang=js&"
export * from "./51rp.vue?vue&type=script&lang=js&"
import style0 from "./51rp.vue?vue&type=style&index=0&id=0afc52fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc52fe",
  null
  
)

export default component.exports